import { topicKey, topicName } from "./text";

/** Place one existing name before an anchor; a missing anchor means the end. */
export function moveBefore(names: readonly string[], name: string, before: string | null): string[] {
  if (!names.includes(name) || name === before) return [...names];
  const next = names.filter((n) => n !== name);
  const at = before === null ? -1 : next.indexOf(before);
  next.splice(at < 0 ? next.length : at, 0, name);
  return next;
}

export type TopicEdit = { type: "add" | "remove" | "rename" | "move"; name: string; to?: string; before?: string | null };

/** One intent against the latest list. Rename/move never resurrect a removed target. */
export function editTopics(names: readonly string[], edit: TopicEdit): string[] {
  const name = topicName(edit.name);
  if (!name) return [...names];
  const current = names.find((n) => topicKey(n) === topicKey(name));
  const anchor = names.find((n) => topicKey(n) === topicKey(edit.before ?? "")) ?? null;
  switch (edit.type) {
    case "add": return current ? [...names] : moveBefore([...names, name], name, anchor);
    case "remove": return names.filter((n) => n !== current);
    case "move": return current ? moveBefore(names, current, anchor) : [...names];
    case "rename": {
      const to = topicName(edit.to ?? "");
      if (!current || !to || names.some((n) => n !== current && topicKey(n) === topicKey(to))) return [...names];
      return names.map((n) => n === current ? to : n);
    }
  }
}
